<template>
<div class="containers">
    <div v-if="goArea == true" class="area-list">
        <CAlert
        v-if="success == true"
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <CAlert
        v-else
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:red;border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <div class="search-area">
            <CRow>
                <CCol sm="5" class="pr-1">
                    <div class="autocomplete">
                        <input type="text"
                                class="form-control"
                                @click="toggleVisiblePegawai()"
                                @blur="toggleCloseVisiblePegawai()"
                                v-model="queryPegawai"
                                v-text="selectedItemPegawai ? selectedItemPegawai['text'] : ''"
                                @keydown.up="upPegawai"
                                @keydown.down="downPegawai"
                                @keydown.enter="selectItemPegawai"
                                placeholder="Pilih Pegawai"
                        >
                        <div class="popovers" v-show="visiblePegawai">
                            <div class="options" v-if="matchesPegawai.length != 0 && queryPegawai.length != 0" ref="optionsList">
                                <ul>
                                <li v-for="(match, index) in matchesPegawai"
                                    :key="index"
                                    :class="{ 'selected': (selectedPegawai == index)}"
                                    @click="itemClickedPegawai(index)"
                                    v-text="match['text']"></li>
                                </ul>
                            </div>
                            <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length != 0">
                                Data Tidak Ditemukan
                            </div>
                            <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length == 0">
                                Start Typing...
                            </div>
                        </div>
                    </div>
                </CCol>
                <CCol sm="5" class="pr-1 pl-1">
                    <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataStatus" class="form-control" v-model="status" placeholder="Status"></model-select>
                </CCol>
                <CCol sm="2">
                    <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="6"></CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                    <img class="mt-1 mr-4" :src="moreIcon" width="20px" height="20px" style="float:right"/>
                    <img class="mr-4 mt-1" v-if="datas.length != 0" @click="getDownload()" style="float:right;cursor:pointer" :src="downloadIcon" title="export to excel"  width="20px" height="20px"/>
                    <img class="mr-4 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/>
                </CCol>
            </CRow>
        </div>
        <Tables @sort="sorting" @edit="editData" :data="datas" :errors="errorMessage"></Tables>
    </div>
    <div v-else class="area-edit">
        <CRow class="area-back">
            <CCol sm="12">
                <img class="mt-2 mb-2" @click="moving()" :src="backIcon" width="20px" height="20px" style="float:left;cursor:pointer"/>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CRow class="area-input">
            <CCol sm="12">
                <CRow>
                    <CCol sm="3">
                        Nama
                    </CCol>
                    <CCol sm="9">
                        : <span class="font-weight-bold">{{dataNama}}</span>
                    </CCol>
                </CRow>
                <CRow class="mt-2">
                    <CCol sm="3">
                        Jabatan
                    </CCol>
                    <CCol sm="9">
                        : <span>{{dataJabatan}}</span>
                    </CCol>
                </CRow>
                <CRow class="mt-2">
                    <CCol sm="3">
                        Tanggal Pengajuan
                    </CCol>
                    <CCol sm="9">
                        : {{separatorTanggal(dataTglPengajuan)}}
                    </CCol>
                </CRow>
                <CRow class="mt-2">
                    <CCol sm="3">
                        Nomor Kartu
                    </CCol>
                    <CCol sm="9">
                        : {{dataNoKartu}}
                    </CCol>
                </CRow>
                <CRow class="mt-2">
                    <CCol sm="3">
                        Nomor Reimburse
                    </CCol>
                    <CCol sm="9">
                        : {{dataNoReimburs}}
                    </CCol>
                </CRow>
                <CRow class="mt-2">
                    <CCol sm="3">
                        Total Pengajuan
                    </CCol>
                    <CCol sm="9">
                        : {{separatorRupiah(dataTotalPengajuan)}}
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="3">
                        Kloter
                    </CCol>
                    <CCol sm="9">
                        : <span class="font-weight-bold">{{dataNamaKloter}}</span>
                    </CCol>
                </CRow>
                <CRow class="mt-3">
                    <CCol sm="12">
                        <span class="font-weight-bold">Peserta </span>
                        <table>
                            <thead>
                                <tr>
                                    <th class="width:25%">Nama</th>
                                    <th class="width:45%">Diagnosa</th>
                                    <th class="width:15%">Tgl Kwitansi</th>
                                    <th class="width:15%">Biaya</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(body, ids) in dataDaftarPeserta" :key="ids">
                                    <td class="width:25%">{{body.nama}}</td>
                                    <td class="width:45%">{{body.diagnosa}}</td>
                                    <td class="width:15%">{{separatorTanggal(body.tanggalKwitansi)}}</td>
                                    <td class="width:15%">{{separatorRupiah(body.biaya)}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </CCol>
                </CRow>
            </CCol>
        </CRow>
        <CRow class="area-button-submit">
            <CCol sm="12">
                <CButton @click="moving()" type="button" class="btn btn-cancel mr-2">Back</CButton>
                <CButton @click="modalReject = true" class="btn btn-edit-delete mr-2">
                    <span v-if="loadingReject == false">Reject</span>
                    <CSpinner v-else color="default" size="sm"/>
                </CButton>
                <CButton @click="openModal()" class="btn btn-edit-submit">
                    <span v-if="loading == false">Approve</span>
                    <CSpinner v-else color="default" size="sm"/>
                </CButton>
            </CCol>
        </CRow>
    </div>
    <CModal
        size="md"
        :centered="true"
        color="white"
        :show.sync="modalApprove"
        :closeOnBackdrop="false"
        >
        <template #header-wrapper>
            <div class="headers-modal">
                <CRow>
                    <CCol sm="10">
                        <div>Persetujuan Permintaan</div>
                    </CCol>
                    <CCol sm="2" class="text-right">
                        <img :src="closeIcon" @click="closeModal()" style="cursor:pointer" width="20px" height="20px"/>
                    </CCol>
                </CRow>
            </div>
        </template>
        <template #body-wrapper>
            <div style="padding-right:20px;padding-left:20px">
                <CRow>
                    <CCol sm="12">
                        <label>Apakah Anda Yakin Ingin Menyetujui Permintaan Reimburse?</label>
                    </CCol>
                </CRow>
            </div>
            <CRow class="mt-4" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
                <CCol sm="6">
                    <CButton style="width: 100%!important" @click="closeModal()" class="btn-cancel">Back</CButton>
                </CCol>
                <CCol sm="6">
                    <CButton style="width: 100%!important" @click="submit('A')" class="btn-edit-submit">Approve</CButton>
                </CCol>
            </CRow>
        </template>
        <template #footer-wrapper><span></span></template>
    </CModal>

    <CModal
        size="md"
        :centered="true"
        color="white"
        :show.sync="modalPayment"
        :closeOnBackdrop="false"
        >
        <template #header-wrapper>
            <div class="headers-modal">
                <CRow>
                    <CCol sm="10">
                        <div>Pembayaran Reimburse</div>
                    </CCol>
                    <CCol sm="2" class="text-right">
                        <img :src="closeIcon" @click="closeModal()" style="cursor:pointer" width="20px" height="20px"/>
                    </CCol>
                </CRow>
            </div>
        </template>
        <template #body-wrapper>
            <div style="padding-right:20px;padding-left:20px">
                <CRow>
                    <CCol sm="5">
                        Total Pengajuan
                    </CCol>
                    <CCol sm="7">
                        : <span class="font-weight-bold">{{separatorRupiah(dataTotalPengajuan)}}</span>
                    </CCol>
                </CRow>
                <CRow class="mt-3">
                    <CCol sm="12">
                        <label>Masukan nominal yang ingin dibayarkan</label>
                        <input
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                            v-model="totalApprove"
                            @input="rupiahModeUangSaku()"
                            placeholder="Nominal"
                            class="form-control" />
                    </CCol>
                </CRow>
                <CRow class="mt-3">
                    <CCol sm="12">
                        <label>Masukan Keterangan</label>
                        <textarea
                            v-model="keteranganApprove"
                            placeholder="Keterangan"
                            class="form-control" />
                    </CCol>
                </CRow>
                <CRow class="mt-4" v-if="errFlag == true">
                    <CCol sm="12">
                        <span v-if="err == '1'" class="text-danger" style="font-size:12px">*Nominal yang dimasukan melebihi nominal yang di ajukan</span>
                        <span v-if="err == '2'" class="text-danger" style="font-size:12px">*Nominal harus diisi</span>
                        <span v-if="err == '3'" class="text-danger" style="font-size:12px">*Keterangan harus diisi</span>
                </CRow>
            </div>
            <CRow class="mt-4" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
                <CCol sm="6">
                    <CButton style="width: 100%!important" @click="closeModal()" class="btn-cancel">Back</CButton>
                </CCol>
                <CCol sm="6">
                    <CButton style="width: 100%!important" @click="submit('A')" class="btn-edit-submit">Approve</CButton>
                </CCol>
            </CRow>
        </template>
        <template #footer-wrapper><span></span></template>
    </CModal>

    <CModal
        size="md"
        :centered="true"
        color="white"
        :show.sync="modalReject"
        :closeOnBackdrop="false"
        >
        <template #header-wrapper>
            <div class="headers-modal">
                <CRow>
                    <CCol sm="10">
                        <div>Penolakan Permintaan</div>
                    </CCol>
                    <CCol sm="2" class="text-right">
                        <img :src="closeIcon" @click="modalReject = false,keteranganApprove = ''" style="cursor:pointer" width="20px" height="20px"/>
                    </CCol>
                </CRow>
            </div>
        </template>
        <template #body-wrapper>
            <div style="padding-right:20px;padding-left:20px">
                <CRow>
                    <CCol sm="12">
                        <label>Masukan Alasan Penolakan</label>
                        <textarea v-model="keteranganApprove" class="form-control"/>
                    </CCol>
                </CRow>
                <CRow class="mt-4" v-if="errFlag == true">
                    <CCol sm="12">
                        <span v-if="err == '1'" class="text-danger" style="font-size:12px">*Nominal yang dimasukan melebihi nominal yang di ajukan</span>
                        <span v-if="err == '2'" class="text-danger" style="font-size:12px">*Nominal harus diisi</span>
                        <span v-if="err == '3'" class="text-danger" style="font-size:12px">*Keterangan harus diisi</span>
                </CRow>
            </div>
            <CRow class="mt-4" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
                <CCol sm="6">
                    <CButton style="width: 100%!important" @click="modalReject = false,keteranganApprove = ''" class="btn-cancel">Back</CButton>
                </CCol>
                <CCol sm="6">
                    <CButton style="width: 100%!important" @click="submit('R')" class="btn-edit-delete">Reject</CButton>
                </CCol>
            </CRow>
        </template>
        <template #footer-wrapper><span></span></template>
    </CModal>
</div>
</template>

<script>
import Tables from '../../../component/tableReimburs'
import { ModelSelect } from 'vue-search-select'
import {DataApi} from "../../../service/DataApi";

const xlsx = require('json-as-xlsx')
export default {
    components: {
        Tables,
        ModelSelect
    },
    data() {
        return {
            // data search pegawai
            dataPegawai: [],
            titlePegawai:"Pilih Pegawai",
            selectedItemPegawai: null,
            selectedPegawai: 0,
            queryPegawai: '',
            visiblePegawai: false,

            dataStatus: [],
            status: {
                value: '',
                text: ''
            },

            success: true,
            // datas
            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            backIcon: require('../../../assets/menu/icon_goback.svg'),
            closeIcon: require('../../../assets/menu/icon_close.svg'),
            downloadIcon: require('../../../assets/menu/icon_download_excel.svg'),
            classReload: 'reloadOff',
            datas: [],
            goArea: true,
            loading: false,
            loadingReject: false,
            alertMess: '',
            currentAlertCounter: 0,

            // data model
            dataTglPengajuan: '',
            dataNama: '',
            dataIcon: '',
            dataDaftarPeserta: '',
            dataNoKartu: '',
            dataJabatan: '',
            dataNoReimburs: '',
            dataNamaKloter: '',
            dataTotalPengajuan: '',
            totalApprove: '',
            modalApprove: false,
            modalPayment: false,
            modalReject: false,
            keteranganApprove: '',

            // paging
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            // filter

            // error
            errorMessage: '',
            errFlag: false,
            err: '',
            flagSearch: false
        }
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        queryPegawai() {
            this.flagSearch = true
            this.getDataPegawai()
        },
        status() {
            this.flagSearch = true
        },
        goArea() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        }
    },
    computed: {
        matchesPegawai() {
            if (this.queryPegawai == '') {
                return [];
            }
            return this.dataPegawai.filter((item) => item['text'].toLowerCase().includes(this.queryPegawai.toLowerCase()))
        },
    },
    methods: {
        /**
         * SEARCH PEGAWAI
         */
        getDataPegawai() {
            let payload = {
                bidang: '',
                jabatan: '',
                limit: 10,
                nama: this.queryPegawai,
                pageIn: 1,
                pegawaiId: '',
                tipePegawai: ''
            }
            DataApi.post("pegawai/get", payload)
            .then(res => {
                this.dataPegawai = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].nik,
                        text: tempData[i].nama + ' - ' + tempData[i].nik
                    }
                    this.dataPegawai.push(onPush)
                }
            })
        },
        toggleVisiblePegawai() {
            this.visiblePegawai = true;
        },
        hidePegawai() {
            this.visiblePegawai = false;
        },
        toggleCloseVisiblePegawai() {
            setTimeout(this.hidePegawai, 1000);
        },
        itemClickedPegawai(index) {
            this.selectedPegawai = index;
            this.selectItemPegawai();
        },
        selectItemPegawai() {
            if (!this.matchesPegawai.length) {
            return;
            }
            this.selectedItemPegawai = this.matchesPegawai[this.selectedPegawai];
            this.visiblePegawai = false;
            this.queryPegawai = this.selectedItemPegawai.text
            if (this.shouldReset) {
            this.queryPegawai = '';
            this.selectedPegawai = 0;
            }
        },
        upPegawai() {
            if (this.selectedPegawai == 0) {
            return;
            }
            this.selectedPegawai -= 1;
            this.scrollToItemPegawai();
        },
        downPegawai() {
            if (this.selectedPegawai >= this.matchesPegawai.length - 1) {
            return;
            }
            this.selectedPegawai += 1;
            this.scrollToItemPegawai();
        },
        scrollToItemPegawai() {
            this.$refs.optionsList.scrollTop = this.selectedPegawai * this.itemHeight;
        },

        getDataStatus() {
            this.dataStatus = [{ value: '', text: 'Semua' }]
            let payload = {
                aktif: "1",
                description: "",
                fieldReason: "",
                isApproval: "",
                isPegawaiAtasan: "",
                limit: 9999,
                nama: "",
                modul: 2,
                pageIn: 1
            }
            DataApi.post("overtime/status/approval/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    let datas = response.data.data
                    var i
                    for(i=0;i<datas.length;i++) {
                        let onPush = {
                            value: datas[i].unix,
                            text: datas[i].nama
                        }
                        this.dataStatus.push(onPush)
                    }
                }
            })
        },

        /**
         * GET DATA
         */
        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.nama.toLowerCase() < b.nama.toLowerCase()) {
                        return -1
                    }
                    if (a.nama.toLowerCase() > b.nama.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.alamat.toLowerCase() < b.alamat.toLowerCase()) {
                        return -1
                    }
                    if (a.alamat.toLowerCase() > b.alamat.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 2) {
                function compare(a,b) {
                    if (a.kota.toLowerCase() < b.kota.toLowerCase()) {
                        return -1
                    }
                    if (a.kota.toLowerCase() > b.kota.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 3) {
                function compare(a,b) {
                    if (a.provinsi.toLowerCase() < b.provinsi.toLowerCase()) {
                        return -1
                    }
                    if (a.provinsi.toLowerCase() > b.provinsi.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 4) {
                function compare(a,b) {
                    if (a.latitude.toLowerCase() < b.latitude.toLowerCase()) {
                        return -1
                    }
                    if (a.latitude.toLowerCase() > b.latitude.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 5) {
                function compare(a,b) {
                    if (a.longitude.toLowerCase() < b.longitude.toLowerCase()) {
                        return -1
                    }
                    if (a.longitude.toLowerCase() > b.longitude.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 6) {
                function compare(a,b) {
                    if (a.radius.toLowerCase() < b.radius.toLowerCase()) {
                        return -1
                    }
                    if (a.radius.toLowerCase() > b.radius.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let pegawai = ''
            if(this.queryPegawai != '') {
                pegawai = this.queryPegawai.split(" - ")[0]
            } else {
                pegawai = ''
            }
            let limit = this.size
            let page = this.page
            let status = this.status.value

            let payload = {
                export: 'T',
                limit: limit,
                nama: pegawai,
                pageIn: page,
                status: status
            }
            DataApi.post("/reimburse/lihat/backoffice", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        getDownload() {
            if(this.datas.length != 0) {
                let pegawai = ''
                if(this.queryPegawai != '') {
                    pegawai = this.queryPegawai.split(" - ")[0]
                } else {
                    pegawai = ''
                }
                let limit = this.totalRow
                let page = 1
                let status = this.status.value

                let payload = {
                    export: 'Y',
                    limit: limit,
                    nama: pegawai,
                    pageIn: page,
                    status: status
                }
                this.$store.state.loadingScreen = true
                DataApi.post("/reimburse/lihat/backoffice", payload)
                .then(res => {
                    let response = res.data
                    if(response.success == true) {
                        let temp = response.data.data
                        let fileName = 'Daftar Reimburse'
                        let data = [
                            {
                                sheet: 'Reimburse',
                                columns: [
                                    { label: 'Nomor Reimburse', value: 'noReimburse'  },
                                    { label: 'Nama Prinsipal', value: 'namaPrinsipal'  },
                                    { label: 'NIP Prinsipal', value: 'nipPrinsipal'  },
                                    { label: 'Nomor Kartu Prinsipal', value: 'noKartuPrinsipal'  },
                                    { label: 'Nama Peserta', value: 'namaPeserta'  },
                                    { label: 'Nomor Kartu Peserta', value: 'noKartuPeserta'  },
                                    { label: 'Diagnosa', value: 'diagnosa'  },
                                    { label: 'Biaya', value: 'biaya'  },
                                    { label: 'Tanggal Kwitansi', value: 'tanggalKwitansi'  },
                                    { label: 'Status', value: 'status'  },
                                    { label: 'URL File', value: 'urlFile'  },
                                ],
                                content: temp
                            }
                        ]            
                        let settings = {
                            fileName: fileName
                        }
                        xlsx(data, settings)
                    }
                    this.$store.state.loadingScreen = false
                })
            }
        },
        findData() {
            this.getData()
        },
        reload() {
            this.queryPegawai = ''
            this.status.value = ''
            this.status.text = ''
            this.flagSearch = true
            this.getData()
            this.getDataStatus()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },

        /**
         * ADD DATA
         */
        moving() {
            setTimeout(this.moveArea, 600);
        },
        moveArea() {
            if(this.goArea == true) {
                this.goArea = false
            } else {
                this.goArea = true
                this.err = ''
                this.errFlag = false
            }
        },
        submit(value) {
            let keterangan = ''
            let nominal = ''
            let unix = this.unix
            let payload = ''
            let val = value
            if(this.dataIcon == 'Y') {
                if(val == 'A') {
                    let val1 = false
                    let val2 = false
                    let val3 = false
                    let nom = this.totalApprove
                    let pengajuan = this.dataTotalPengajuan
                    let nominal = ''
                    if(nom == '') {
                        val2 = true
                        this.err = '2'
                    } else {
                        val2 = false
                        let clear = nom.replace("Rp. ", '')
                        var i
                        for(i=0;i<clear.length;i++) {
                            if(clear[i] == '.') {
                                //
                            } else {
                                nominal += clear[i]
                            }
                        }

                        if(parseInt(nominal) > parseInt(pengajuan)) {
                            this.err = '1'
                            val1 = true
                        } else {
                            val1 = false
                        }

                        if(this.keteranganApprove == '') {
                            val3 = true
                            this.err = '3'
                        } else {
                            val3 = false
                        }
                    }
                    if(val1 == false && val2 == false && val3 == false) {
                        this.err = ''
                        keterangan = this.keteranganApprove
                        payload = {
                            keteranganApprove: keterangan,
                            status: val,
                            totalApprove: parseInt(nominal),
                            unix: unix
                        }
                        this.goSave(payload)
                        this.modalPayment = false
                    } else {
                        this.errFlag = true
                    }
                } else {
                    keterangan = this.keteranganApprove
                    if(keterangan == '') {
                        this.errFlag = true
                        this.err = '3'
                    } else {
                        nominal = '0'
                        payload = {
                            keteranganApprove: keterangan,
                            status: val,
                            totalApprove: parseInt(nominal),
                            unix: unix
                        }
                        this.goSave(payload)
                        this.loadingReject = true
                        this.modalReject = false
                    }
                }
            } else if(this.dataIcon == 'T') {
                if(val == 'A') {
                    keterangan = ''
                    nominal = '0'
                    payload = {
                        keteranganApprove: keterangan,
                        status: val,
                        totalApprove: parseInt(nominal),
                        unix: unix
                    }
                    this.goSave(payload)
                    this.modalApprove = false
                    this.loading = true
                } else {
                    keterangan = this.keteranganApprove
                    if(keterangan == '') {
                        this.errFlag = true
                        this.err = '3'
                    } else {
                        nominal = '0'
                        payload = {
                            keteranganApprove: keterangan,
                            status: val,
                            totalApprove: parseInt(nominal),
                            unix: unix
                        }
                        this.goSave(payload)
                        this.loadingReject = true
                        this.modalReject = false
                    }
                }
            }
        },
        goSave(payload) {
            DataApi.post("/reimburse/save/backoffice", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.getData()
                this.moving()
                this.modalApprove = false
                this.modalPayment = false
                this.modalReject = false
                this.totalApprove = ''
                this.loading = false
                this.loadingReject = false
                this.currentAlertCounter = 7
                this.keteranganApprove = ''
            })
        },

        /**
         * EDIT DATA
         */
        editData(value) {
            let generate = this.datas[value]
            this.dataTglPengajuan = generate.createdDate
            this.dataIcon = generate.nonIcon
            this.dataJabatan = generate.jabatan
            this.dataDaftarPeserta = generate.daftarPeserta
            this.dataTotalPengajuan = generate.totalPengajuan
            this.dataNama = generate.namaPegawai
            this.dataNamaKloter = generate.kloter
            this.dataNoKartu = generate.noKartuPeserta
            this.dataNoReimburs = generate.noReimburse
            this.unix = generate.unix
            this.moving()
        },
        separatorTanggal(val) {
            let tanggal = val.split("-")[2]
            let bulanTemp = val.split("-")[1]
            let tahun = val.split("-")[0]
            let bulan = ''
            if(bulanTemp == '01' || bulanTemp == '1') {
                bulan = 'Jan'
            } else if(bulanTemp == '02' || bulanTemp == '2') {
                bulan = 'Feb'
            } else if(bulanTemp == '03' || bulanTemp == '3') {
                bulan = 'Mar'
            } else if(bulanTemp == '04' || bulanTemp == '4') {
                bulan = 'Apr'
            } else if(bulanTemp == '05' || bulanTemp == '5') {
                bulan = 'Mei'
            } else if(bulanTemp == '06' || bulanTemp == '6') {
                bulan = 'Jun'
            } else if(bulanTemp == '07' || bulanTemp == '7') {
                bulan = 'Jul'
            } else if(bulanTemp == '08' || bulanTemp == '8') {
                bulan = 'Agu'
            } else if(bulanTemp == '09' || bulanTemp == '9') {
                bulan = 'Sep'
            } else if(bulanTemp == '10') {
                bulan = 'Okt'
            } else if(bulanTemp == '11') {
                bulan = 'Nov'
            } else if(bulanTemp == '12') {
                bulan = 'Des'
            }
            return tanggal + ' ' + bulan + ' ' + tahun
        },
        separatorRupiah(val) {
            let leng = val.length
            let sisa 	= leng % 3
            let rupiah 	= val.substr(0, sisa)
            let ribuan 	= val.substr(sisa).match(/\d{3}/g)
                
            if (ribuan) {
                let separator = sisa ? '.' : ''
                rupiah += separator + ribuan.join('.')
            }
            return 'Rp. ' + rupiah 
        },
        rupiahModeUangSaku() {
            var number_string = this.totalApprove.toString().replace(/[^,\d]/g, '')
            var split           = number_string.split(',')
            var sisa             = split[0].length % 3
            var rupiah             = split[0].substr(0, sisa)
            var ribuan             = split[0].substr(sisa).match(/\d{3}/gi)
            var prefix = "Rp. "
        
            // tambahkan titik jika yang di input sudah menjadi angka satuan ribuan
            if(ribuan){
                var separator = sisa ? '.' : '';
                rupiah += separator + ribuan.join('.');
            }
        
            rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
            let hasil = prefix == undefined ? rupiah : (rupiah ? 'Rp. ' + rupiah : '');
            this.totalApprove = hasil
        },
        openModal() {
            if(this.dataIcon == 'T') {
                this.modalApprove = true
            } else if(this.dataIcon == 'Y') {
                this.modalPayment = true
            }
        },
        closeModal() {
            if(this.dataIcon == 'T') {
                this.modalApprove = false
            } else if(this.dataIcon == 'Y'){
                this.modalPayment = false
                this.totalApprove = ''
                this.keteranganApprove = ''
            }
        }

    },
    mounted() {
        this.errorMessage = 'Find Your Data'
        this.getDataPegawai()
        this.getDataStatus()
    }
}
</script>
<style scoped>
::v-deep .modal-header {
    border-bottom: none !important;
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.btn-search {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}

.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-edit-delete {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:red;
    color: white;
    font-size: 14px;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 6px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 6px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}

.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input, .area-input .model-select {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
    padding-top: 32px;
}
.select-invalid {
    border: 1px solid #e55353 !important;
}
.select-valid {
    border: 1px solid #2eb85c !important;
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.cards-image {
    position: absolute;
    text-align: center;
    font-size: 27px;
    color: rgba(96, 96, 96, 1);
    line-height: 50px;
    border: 1px dotted rgba(221, 221, 221, 1);
    width: 56px !important;
    background-color: rgba(250, 250, 250, 1);
    height: 56px !important;
}
.invalid-feedback {
    margin-top: -16px;
    float: right;
}
table {
    width: 100%;
}
table thead tr {
    background-color: rgba(244, 244, 244, 1);
}
thead th {
    padding-top: 16px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 16px;
}
tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 20px;
    padding-right: 20px;
}
td,th {
    overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 14px;
}
tr:nth-child(even) {
    background-color: rgba(252, 252, 252, 1);
}
.modal-button-cancel {
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: white;
    color: rgba(16, 16, 16, 1);
}
.modal-button-cancel:hover {
    border: 1px solid rgba(48, 107, 240, 1);
    background-color: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
</style>
